export default "__VITE_ASSET__1bd5472e__"